import AlertColoredOutlinedSVG from './icon_alert_colored_outlined.svg';
import withIconProps from './withIconProps';

export default withIconProps(AlertColoredOutlinedSVG);
